import ParameterTable from '../components/ParameterTable';
import { screenshotParameters } from '../data/parameters';

export default function ScreenshotParameters() {
  return (
    <section id="parameters" className="mb-16">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Parameters</h3>
      <p className="text-gray-700 mb-6">
        The following parameters can be included in the request body to customize your screenshot:
      </p>
      <ParameterTable parameters={screenshotParameters} />
    </section>
  );
}